import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static values = { id: String }

  open(event) {
    event?.preventDefault()
    document.dispatchEvent(
      new CustomEvent('slideover:open', {
        detail: { id: this.idValue, trigger: this.element },
      })
    )
  }
}
